import { UsedProductsList } from "@/@types/index";
import { UsedProductsListResponse } from "../usedProduct/models/UsedProductListResponse";

export function mapUsedProductList(response: UsedProductsListResponse): UsedProductsList {
    return {
        data: {
            usedProducts: response.data.used_products.map(product => ({
                image: product.image,
                name: product.name,
                model: product.model,
                year: product.year,
                price: product.price,
                currency: product.currency,
                customPrice: product.custom_price,
                customCurrency: product.custom_currency,
                offer: product.offer,
                slug: product.slug,
            })),
        },
        links: {
            first: response.links.first,
            last: response.links.last,
            prev: response.links.prev,
            next: response.links.next,
        },
        meta: {
            currentPage: response.meta.current_page,
            from: response.meta.from,
            lastPage: response.meta.last_page,
            links: response.meta.links.map(link => ({
                url: link.url,
                label: link.label,
                active: link.active,
            })),
            path: response.meta.path,
            perPage: response.meta.per_page,
            to: response.meta.to,
            total: response.meta.total,
        },
    };
}